var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('div',{staticClass:"mr-2",style:(_vm.legendStyle)}),_c('div',{staticClass:"sm__legend-text-area"},[_c('sm-text',{attrs:{"text":_vm.label,"format":_vm.format,"color":"black"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }